import { render, staticRenderFns } from "./RoomClothes.vue?vue&type=template&id=45bb1a5a&scoped=true&"
import script from "./RoomClothes.vue?vue&type=script&lang=js&"
export * from "./RoomClothes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb1a5a",
  null
  
)

export default component.exports